// extracted by mini-css-extract-plugin
export default {"walletContainer":"Login_walletContainer__YYzav"};